export default {
	MAINTENANCE: 'companies/:company_id/maintenance/',
	MAINTENANCE_GET_EXTRAS: 'companies/:company_id/maintenance/extras/',
	MAINTENANCE_TYPES: 'companies/:company_id/maintenance/types/',
	MAINTENANCE_UPDATE_STATUS: 'companies/:company_id/maintenance/update-status/',
	MAINTENANCE_MESSAGE: 'companies/:company_id/maintenance/message/'
}
